import axios from 'axios'

export class Partnerschaft{
    static async getPartnerfeuerwehren(feuerwehrID){
        try{
            const response = await axios.get(
                'https://feuerwehr-server.org:5000/partnerfeuerwehren', { params: { feuerwehrID: feuerwehrID } }
            );
            
            return response.data;
        } catch (err){
            console.error(err);
            return false;
        }
    }

    static async add(partnerData){
        try {
            const response = await axios.post('https://feuerwehr-server.org:5000/addPartner', partnerData);
            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    static async delete(partnerData){
        try {
            const response = await axios.delete('https://feuerwehr-server.org:5000/deletePartner', { data: partnerData });
            return response.data;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
}
